import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6022fac5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-history-row" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 탑승일 ", -1 /* HOISTED */))
const _hoisted_4 = { class: "description bold" }
const _hoisted_5 = { class: "row line" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "탑승노선", -1 /* HOISTED */))
const _hoisted_7 = { class: "description-wrapper" }
const _hoisted_8 = { class: "description" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "신고유형", -1 /* HOISTED */))
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "row report-type" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "차량정보", -1 /* HOISTED */))
const _hoisted_14 = { class: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" 탑승일 "),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString($setup.onBoardDateTime), 1 /* TEXT */)
    ]),
    _createCommentVNode(" 탑승노선 "),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode($setup["LineSetTypeChip"], {
          class: "chip",
          isSmallSize: true,
          lineTypeName: $props.reportHistory.lineTypeName,
          lineTypeCode: $props.reportHistory.lineTypeCode
        }, null, 8 /* PROPS */, ["lineTypeName", "lineTypeCode"]),
        _createElementVNode("span", _hoisted_8, _toDisplayString($setup.useGetLineRouteName(
            $props.reportHistory.lineTypeCode,
            $props.reportHistory.lineRouteName,
            $props.reportHistory.lineRouteNo
          )), 1 /* TEXT */)
      ])
    ]),
    _createCommentVNode(" 신고유형 "),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("span", {
        class: "report-type",
        innerHTML: $setup.DOMPurify.sanitize($setup.reportNameAndCountHTMLTexts)
      }, null, 8 /* PROPS */, _hoisted_11)
    ]),
    _createCommentVNode(" 차량정보 "),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("span", _hoisted_14, _toDisplayString($setup.carNoAndVendor), 1 /* TEXT */)
    ])
  ]))
}